const map = {
	"./ModuleApiSchema/registry/routes.js": 43680,
	"./ModuleCompany/ConfigSystem/registry/routes.js": 20018,
	"./ModuleConsole/ServiceRegister/registry/routes.js": 12871,
	"./ModuleConsole/ServiceSchema/registry/routes.js": 68601,
	"./ModuleCore/ApiKeyCredentials/registry/routes.js": 72630,
	"./ModuleCore/ApiKeyPermission/registry/routes.js": 77115,
	"./ModuleCore/ApiKeyPermissionGroup/registry/routes.js": 8854,
	"./ModuleCore/ApiKeyPermissionGroupCredentials/registry/routes.js": 84284,
	"./ModuleCore/ApiKeyPermissionGroupMapping/registry/routes.js": 46516,
	"./ModuleCore/ApiKeyPermissionMapping/registry/routes.js": 80251,
	"./ModuleCore/AuthzPermission/registry/routes.js": 62478,
	"./ModuleCore/AuthzPermissionGroup/registry/routes.js": 48045,
	"./ModuleCore/AuthzPermissionGroupMapping/registry/routes.js": 54033,
	"./ModuleCore/AuthzSubject/registry/routes.js": 15351,
	"./ModuleCore/AuthzSubjectPermission/registry/routes.js": 60264,
	"./ModuleCore/AuthzSubjectPermissionGroup/registry/routes.js": 33767,
	"./ModuleCore/CacheSystem/registry/routes.js": 59898,
	"./ModuleCore/ConfigSystem/registry/routes.js": 66228,
	"./ModuleCore/Tenant/registry/routes.js": 15215,
	"./ModuleCore/TenantAdminAuditLog/registry/routes.js": 12893,
	"./ModuleCore/TenantAuthPolicy/registry/routes.js": 67931,
	"./ModuleCore/TenantInvitation/registry/routes.js": 68972,
	"./ModuleCore/TenantMember/registry/routes.js": 22461,
	"./ModuleCore/TenantUserMapping/registry/routes.js": 82722,
	"./ModuleCore/User/registry/routes.js": 61200,
	"./ModuleCore/UserForceSession/registry/routes.js": 86597,
	"./ModuleCore/UserLoginActivity/registry/routes.js": 7012,
	"./ModuleCore/UserTwoFaCredential/registry/routes.js": 45418,
	"./ModuleCrm/ConfigSystem/registry/routes.js": 44311,
	"./ModulePersonalize/PnlConfigSystem/registry/routes.js": 27467,
	"./ModulePrice/ConfigSystem/registry/routes.js": 73008,
	"./ModuleRole/GrantedUser/registry/routes.js": 75802,
	"./ModuleRole/Permission/registry/routes.js": 28633,
	"./ModuleRole/PermissionGroup/registry/routes.js": 57236,
	"./ModuleRole/PermissionGroupMapping/registry/routes.js": 90998,
	"./ModuleRole/PermissionGroupUser/registry/routes.js": 85859,
	"./ModuleRole/UserAuthority/registry/routes.js": 96190,
	"./ModuleRole/UserAuthorityMapping/registry/routes.js": 73116
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78972;